<template>
  <div>
    <a-row>
      <a-tabs default-active-key="1">
        <a-tab-pane tab="ESTRUCTURA" key="1">
          <g-master :name="master.endpoint"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="60%"
                    ref="master"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                    <a-input
                      v-decorator="['nombre', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('SQL')">
                    <a-textarea
                      v-decorator="['sql', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo')"
                              :formItemConfig="fiOptions"
                              :decorator="['tipo', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="tipo_estructura">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Estado')">
                    <a-checkbox
                      v-decorator="['activo', {valuePropName: 'checked',  rules: [{ required: false, message: 'Valor requerido'}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="NODOS" key="1">
              <nomina-elect-nodos v-if="idSeleccionado" :estructura_id="idSeleccionado"></nomina-elect-nodos>
              <span v-else>Seleccione una formulario para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_estructura: {
          h_lookup_type: 'NOMINA_ELECTRONICA_TIPO_ESTRUCTURA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'nomelect_estructuras',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            allowSelect: true,
            selectedRows: [],
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'SQL', dataIndex: 'sql', sorter: true},
              {title: 'Tipo', dataIndex: 'tipo', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'nombre'},
            {name: 'sql'},
            {name: 'tipo'},
            {name: 'activo', type: 'boolean'}
          ]
        }
      }
    },
    computed: {
      idSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/NomElect/NomElectEstructuras.vue